import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log to console only — never surface stack traces or private values to the visitor.
    // Production monitoring (e.g. Sentry) is an owner-configured action; see docs.
    console.error("UI error boundary:", error?.message, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error" className="min-h-screen grid place-items-center bg-cream px-6 text-center text-olive-deep">
          <div className="max-w-md">
            <p className="font-script text-4xl text-terra">Oops</p>
            <h1 className="mt-3 font-serif text-3xl">Noe gikk galt.</h1>
            <p className="mt-3 text-olive/70">Vi klarte ikke å vise denne siden akkurat nå. Prøv å laste på nytt.</p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <button onClick={() => window.location.reload()} data-testid="app-error-reload"
                className="rounded-md bg-terra px-7 py-3 text-cream text-[12px] font-semibold uppercase tracking-[0.1em] hover:bg-olive-deep transition-colors">
                Last inn på nytt
              </button>
              <a href="/" className="rounded-md border border-olive/40 px-7 py-3 text-[12px] font-semibold uppercase tracking-[0.1em] hover:bg-olive-deep hover:text-cream transition-colors">
                Til forsiden
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
